module.exports = __webpack_public_path__ + "static/media/doc-submitted.74a4976a.svg";